import { useEffect, useRef } from 'react'
import { isElectron, notifyIfBackground, updateTray } from '@/lib/electron'

type ClipLike = {
  _id: string
  videoStatus?: string
  title?: string
}

export function useDesktopNotifications(
  clips: ClipLike[] | undefined,
  projectTitle?: string,
) {
  const prevStatusMap = useRef<Map<string, string>>(new Map())

  useEffect(() => {
    if (!isElectron() || !clips) return

    const prev = prevStatusMap.current
    const generating = clips.some(c =>
      c.videoStatus === 'generating_video' || c.videoStatus === 'generating_image'
    )

    for (const clip of clips) {
      const oldStatus = prev.get(clip._id)
      const newStatus = clip.videoStatus

      if (oldStatus && oldStatus !== newStatus) {
        if (
          (oldStatus === 'generating_video' || oldStatus === 'generating_image') &&
          newStatus === 'completed'
        ) {
          notifyIfBackground(
            'Clip ready',
            clip.title || 'Your clip has finished rendering',
          )
        }
        if (
          (oldStatus === 'generating_video' || oldStatus === 'generating_image') &&
          newStatus === 'failed'
        ) {
          notifyIfBackground(
            'Generation failed',
            clip.title || 'A clip failed to render',
          )
        }
      }
    }

    if (generating) {
      updateTray('generating', projectTitle)
    } else {
      updateTray('idle', projectTitle)
    }

    const next = new Map<string, string>()
    for (const clip of clips) {
      if (clip.videoStatus) next.set(clip._id, clip.videoStatus)
    }
    prevStatusMap.current = next
  }, [clips, projectTitle])
}
